import React from "react";
import './organization-tournament.scss'
import { GSInfoGroup, GSActionBar, GSImage } from "golfstatus_react_components";
import {  getDate } from "../../helpers/Dates";
import { faClone } from "@fortawesome/free-solid-svg-icons";

const OrganizationTournament = (props) => {
  const {tournament}  = props

  const goToCopyForm = (e) => {
    e?.stopPropagation();
    window.open(
      `${process.env.REACT_APP_GOLFSTATUS_TMS_URL}/tournaments/copy/${tournament.id}`
    );
  }

  const getTournamentDataGroup = (tournament) => {
    let item = [
      {
        fit: 'stretch',
        sections: [
          {
            
            sectionItems: [
              {
                type: "primary full-width",
                value: (
                  <GSActionBar
                    header={
                      <GSImage size="x-small wide" src={tournament?.logo} />
                    }
                    pageActions={[
                      {
                        buttonTitle: tournament?.state,
                        type: `status ${tournament.state} secondary pill`,
                      },
                      {
                        actionIcon: faClone,
                        type: "secondary transparent grey",
                        actionClick: goToCopyForm,
                      }
                    ]}
                  />
                ),
              },
            ],
          },
          {
            sectionItems: [
              { type: "primary no-wrap", value: tournament?.name },
              {
                type: "secondary no-wrap",
                value: tournament?.organization?.name,
              },
            ],
          },
          {
            sectionItems: [
              {
                type: "secondary no-wrap",
                value: tournament?.numberOfRounds > 1 ?  `${getDate(tournament?.startAt)} - ${getDate(tournament?.endAt)}`: getDate(tournament?.startAt),
              },
              {
                type: "secondary no-wrap",
                value: tournament?.facility?.name ?? 'No course',
              },
            ],
          },
        ],
      },
    ];
    return item;
  };
  return(
    <organization-tournament>
      <GSInfoGroup dataGroups={getTournamentDataGroup(tournament)} />
    </organization-tournament>
  )

}

export default OrganizationTournament